import { createFileRoute, redirect } from '@tanstack/react-router'
import { auth } from '@/lib'
import { AccountPage } from '@/components/account/AccountPage'

export const Route = createFileRoute('/_app/account')({
    // beforeLoad: async ({ context, location }) => {
    //     console.log('Account beforeLoad - Checking session via Better Auth');

    //     // Since this is under _app, the parent route already handles auth
    //     // Additional guard for direct navigation
    //     const session = await context.auth.getSession();
    //     if (!session?.data?.user) {
    //         throw redirect({
    //             to: '/login',
    //             search: {
    //                 redirect: location.href,
    //             },
    //         });
    //     }
    // },
    component: RouteComponent,
})

function RouteComponent() {
    // const { isAuthenticated, isLoading, user } = useAuth();

    const { data, isPending } = auth.useSession()
    console.log("🚀 ~ RouteComponent ~ user:", data)

    // Show loading while checking authentication
    if (isPending) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
                    <p className="mt-2 text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    // Show nothing while redirecting (if not authenticated)
    if (!data?.user) {
        return null;
    }

    return <AccountPage />;
}